import React from 'react';
import {Redirect} from 'react-router-dom';
import {useEvent} from '../../../data/hooks/eventHooks';
import {useI18n} from '../../../data/hooks/i18nHooks';
import { useEventQuestion } from '../../../data/hooks/questions/useEventQuestion';
import WaitWhileBusy from '../../WaitWhileBusy';
import {AlphabeticalParticipantsList} from '../../elements/ParticipantsList';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadParticipants from '../../loaders/LoadParticipants';
import Screen from '../Screen';
import resolvePath from '../../../misc/resolvePath';
import {useEventParticipantsList} from '../../../data/hooks/participant/useEventParticipantsList';

const EventQuestsQuestionFavorited = props => {
    const {eventId, questionId} = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        question = useEventQuestion(eventId, questionId),
        participants = useEventParticipantsList(
            eventId,
            question.favorite_users.map(userId => ({userId}))
        );

    const header = (
        <TopBarEvent event={event} returnURL="..">
            {i18n['label.participants']}
        </TopBarEvent>
    );

    if (!participants.length) {
        return <Redirect to={resolvePath(location.pathname, '..')} />;
    }

    return (
        <Screen header={header}>
            <AlphabeticalParticipantsList event={event} participants={participants} savePosition={`event-${event.id}/quest-${question.id}`} />
        </Screen>
    );
};

export default props => (
    <LoadParticipants eventId={props.match.params.eventId}>
        <WaitWhileBusy>
            <EventQuestsQuestionFavorited {...props.match.params} />
        </WaitWhileBusy>
    </LoadParticipants>
);
